import { Link } from "react-router-dom";
import { Button, Row, Col, Typography } from "antd";
import VouchersTable from "./VouchersTable";
import { ROUTES } from "@/consts";
import TiersTabButtons from "../Tiers/TiersTabButtons";

const { Title } = Typography;

const Vouchers = () => (
	<>
		<Row justify="space-between" align="middle">
			<Col>
				<Title level={3} style={{ marginBottom: 20 }}>
					Incentives Management
				</Title>
				<TiersTabButtons />
			</Col>
			<Row justify="end" style={{ marginBottom: 20 }}>
				<Link to={ROUTES.CreateVoucher}>
					<Button type="primary">Add New Voucher</Button>
				</Link>
			</Row>
		</Row>

		<VouchersTable />
	</>
);

export default Vouchers;
